import React from "react";
import { useSelector } from "react-redux";
import { ChartBlock } from "../../../../components/charts/ChartBlock/ChartBlock";

const PredictionChart = () => {
  const predictionChart = useSelector((state) => state.numberOfActiveMembersBy.predictionChart);

  return (
    <ChartBlock
      chart={predictionChart}
      chartId="members-by-status-prediction"
      enableTableView
      enableExportPng
      enableExportExcel
      fileName="prediction-chart"
    />
  );
};

export default PredictionChart;
